import { Component } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { StepSummary, StepsService } from 'src/app/core/steps.service';

@Component({
  selector: 'app-steps-summary',
  templateUrl: './steps-summary.component.html',
  styleUrls: ['./steps-summary.component.scss'],
})
export class StepsSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: StepSummary;

  constructor(private error_service: ErrorService, private steps_service: StepsService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.steps_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
